import type { UseMutationResult } from "@tanstack/react-query";

import { mbcAdminKeys } from "@/hooks/queryKeys";

import { useMbcAdminMutation } from "../../useMbcAdminMutation";
import { deleteCheck } from "../api";

export function useDeleteCheck(): UseMutationResult<void, Error, string> {
  return useMbcAdminMutation(deleteCheck, mbcAdminKeys.checks());
}
